module.exports = __webpack_public_path__ + "img/logo.b5d725dc.png";